var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quoteBasic',{attrs:{"title":'Refer Partner Leads',"propsMode":'new',"quoteType":'leads',"leadSource":'RRL'}})}
var staticRenderFns = []

export { render, staticRenderFns }